export default "__VITE_ASSET__D$hzRe0b__"